import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { paths } from '../paths';

// ----------------------------------------------------------------------

const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  SignUpPage: lazy(() => import('src/pages/auth/jwt/sign-up')),
};

const Amplify = {
  ResetPasswordPage: lazy(() => import('src/pages/auth/amplify/reset-password')),
  UpdatePasswordPage: lazy(() => import('src/pages/auth/amplify/update-password')),
};

const authJwt = {
  path: 'jwt',
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: '欢迎回来', subtitle: '请输入您的手机号和密码登录' },
            }}
          >
            <Jwt.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'sign-up',
      element: (
        <GuestGuard>
          <AuthSplitLayout slotProps={{ section: { title: '创建账号' } }}>
            <Jwt.SignUpPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
  ],
};

const authAmplify = {
  path: 'amplify',
  children: [
    {
      index: true,
      element: <Navigate to={paths.auth.amplify.resetPassword} replace />,
    },
    {
      path: 'reset-password',
      element: (
        <GuestGuard redirectAfterLogin={false}>
          <AuthSplitLayout slotProps={{ section: { title: '忘记密码' } }}>
            <Amplify.ResetPasswordPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'update-password',
      element: (
        <GuestGuard redirectAfterLogin={false}>
          <AuthSplitLayout slotProps={{ section: { title: '更新密码' } }}>
            <Amplify.UpdatePasswordPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authJwt, authAmplify],
  },
];
